import { createFileRoute } from "@tanstack/react-router";

import { throwIfHasNoPermission } from "@/utils/permissions";

import NewsForm from "@/modules/news/admin/components/NewsForm";

export const Route = createFileRoute("/admin/_panel/_news/news/create")({
  component: Component,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "news.news.create");

    return {
      crumb: [
        {
          label: context.t("Create", { ns: "core.shared" }),
        },
      ],
    };
  },
});

function Component() {
  return <NewsForm />;
}
